import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RolesService, RoleDto } from '../../../../services/roles.service';
import { ToastService } from '../../../../services/toast.service';
import { ConfirmationService } from '../../../../services/confirmation.service';

@Component({
  selector: 'app-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.scss']
})
export class RolesListComponent implements OnInit {
  roles: RoleDto[] = [];
  loading = false;

  constructor(
    private rolesService: RolesService,
    private router: Router,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.loadRoles();
  }

  loadRoles(): void {
    this.loading = true;
    this.rolesService.getAllRoles().subscribe({
      next: (roles) => {
        this.roles = roles;
        this.loading = false;
      },
      error: (error) => {
        this.toastService.showToast('error', 'Error al cargar los roles');
        this.loading = false;
        console.error('Error loading roles:', error);
      }
    });
  }

  createRole(): void {
    this.router.navigate(['/config/roles/new']);
  }

  editRole(role: RoleDto): void {
    this.router.navigate(['/config/roles', role.id]);
  }

  async deleteRole(role: RoleDto): Promise<void> {
    if (role.isSystemRole) {
      this.toastService.showToast('warning', 'No se puede eliminar un rol del sistema');
      return;
    }

    const confirmed = await this.confirmationService.confirmDelete(
      'rol',
      `el rol "${role.name}"`
    );

    if (confirmed) {
      this.rolesService.deleteRole(role.id).subscribe({
        next: () => {
          this.toastService.showToast('success', 'Rol eliminado exitosamente');
          this.loadRoles();
        },
        error: (error) => {
          this.toastService.showToast('error', 'Error al eliminar el rol');
          console.error('Error deleting role:', error);
        }
      });
    }
  }

  getRoleBadgeClass(role: RoleDto): string {
    if (role.name === 'SuperAdmin') {
      return 'bg-red-100 text-red-800';
    } else if (role.name === 'Admin') {
      return 'bg-blue-100 text-blue-800';
    } else if (role.name === 'User') {
      return 'bg-green-100 text-green-800';
    }
    return 'bg-gray-100 text-gray-800';
  }
}

